import { createContext, useContext, useState } from "react";

const ThemeContext = createContext();

export const THEMES = {
  dark: {
    name: "dark",
    bg:          "#1C1C1E",
    bgSecond:    "#242427",
    bgCard:      "#2C2C2F",
    bgInput:     "#35353A",
    bgHover:     "#3A3A3F",
    border:      "#3D3D42",
    borderLight: "#4A4A50",
    text:        "#F2F2F7",
    textSub:     "#EBEBF5CC",
    textMuted:   "#8E8E93",
    orange:      "#FF6B2B",
    shadow:      "0 2px 8px rgba(0,0,0,.4)",
    shadowLg:    "0 8px 32px rgba(0,0,0,.5)",
  },
  light: {
    name: "light",
    bg:          "#F5F5F7",
    bgSecond:    "#FFFFFF",
    bgCard:      "#FFFFFF",
    bgInput:     "#F2F2F5",
    bgHover:     "#E8E8EC",
    border:      "#D8D8DC",
    borderLight: "#E0E0E4",
    text:        "#1C1C1E",
    textSub:     "#3A3A3C",
    textMuted:   "#8E8E93",
    orange:      "#FF6B2B",
    shadow:      "0 2px 8px rgba(0,0,0,.08)",
    shadowLg:    "0 8px 32px rgba(0,0,0,.12)",
  }
};

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() =>
    localStorage.getItem("oo_theme") === "light" ? THEMES.light : THEMES.dark
  );
  const toggleTheme = () => {
    const next = theme.name === "dark" ? THEMES.light : THEMES.dark;
    setTheme(next);
    localStorage.setItem("oo_theme", next.name);
  };
  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');
        *, *::before, *::after { box-sizing: border-box; transition: background-color .2s, border-color .15s; }
        body { margin: 0; background: ${theme.bg}; font-family: 'Inter', -apple-system, sans-serif; }
        ::-webkit-scrollbar { width: 5px; height: 5px; }
        ::-webkit-scrollbar-track { background: transparent; }
        ::-webkit-scrollbar-thumb { background: ${theme.border}; border-radius: 10px; }
        input, select, textarea { color-scheme: ${theme.name}; font-family: 'Inter', -apple-system, sans-serif; }
        * { -webkit-font-smoothing: antialiased; }
      `}</style>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() { return useContext(ThemeContext); }
